'use client';

import useDriftStore from '../../stores/DriftStore/useDriftStore';
import useDevStore from '../../stores/useDevStore';

const DevTopWrapper = () => {
	const showRefStatus = useDevStore((s) => s.showRefCode);
	const currentReferralCode = useDriftStore((s) => s.referrerParam);
	const referralAuthority = useDriftStore((s) => s.referredByAuthority);

	return (
		<>
			{showRefStatus && (
				<div className="flex w-full space-x-1 typo-body-xs text-text-default">
					<span>Ref Code : {currentReferralCode}</span>
					<span>Ref Authority : {referralAuthority?.toString()}</span>
				</div>
			)}
		</>
	);
};

export default DevTopWrapper;
